/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppContext } from "../../../context";
import { post } from "../Common/util";
import * as types from "../../../Actions/actionTypes";
import { createStyles } from "@mantine/emotion";

const useStyles = createStyles((theme) => ({
  checkoutContainer: {
    marginTop: "16px",
  },
}));

const Klarna = React.memo((props) => {
  const { itemExpired, setModalOpen } = props;

  const { classes } = useStyles();
  const rdxDispatch = useDispatch();
  const [klarnaApi, setKlarnaApi] = useState();

  const { state } = useContext(AppContext);
  const { config, saleId, userManager } = state;

  console.log("Klarna (re)render ------------------------ ");

  const startKlarnaOnePagePaymentProcessUrl = `${config.apiUri}/api/klarna/v3/onepage/${saleId}`;

  // Get Access Token from user
  let accessToken = null;
  userManager.getUser().then((user) => {
    if (user && user.access_token) {
      accessToken = user.access_token;
    }
  });

  // Abort Klarna UI if item in cart expired
  useEffect(() => {
    if (itemExpired === true) {
      console.log("-- Klarna ABORT from countdown");
      klarnaApi.suspend({
        autoResume: {
          enabled: false,
        },
      });
      setModalOpen(false);
      window.location.reload();
    }
  }, [itemExpired]);

  //On first render - Call external api
  useEffect(() => {
    console.log("-- Klarna - Call API to start payment process");

    const startPaymentProcess = async () => {
      const apiResponse = await post(
        accessToken,
        startKlarnaOnePagePaymentProcessUrl
      );

      if (apiResponse.status !== 200) {
        console.log("-- Klarna ERROR, status:", apiResponse.status);
        rdxDispatch({
          type: types.ERROR,
          payload: "Could_Not_Start_OnePage_Payment_Error",
        });

        //
        //todo: dölj onepage vid error?
        //
      } else {
        let response = await apiResponse.json();

        console.log("-- Klarna - Called api");

        //Apply payload
        var checkoutContainer = document.getElementById(
          "checkout-container-div"
        );
        checkoutContainer.innerHTML = response.snippet;
        var scriptsTags = checkoutContainer.getElementsByTagName("script");

        for (var i = 0; i < scriptsTags.length; i++) {
          var parentNode = scriptsTags[i].parentNode;
          var newScriptTag = document.createElement("script");
          newScriptTag.type = "text/javascript";
          newScriptTag.text = scriptsTags[i].text;
          parentNode.removeChild(scriptsTags[i]);
          parentNode.appendChild(newScriptTag);
        }

        console.log("-- Klarna - Checkout loaded");

        window._klarnaCheckout(function (api) {
          console.log("-- Klarna - Checkout loaded callback");
          setKlarnaApi(api);

          api.on({
            change: function (data) {
              api.suspend();
              console.log("-- Klarna - onChange start", data);
              let uri = response.updateUri;

              fetch(`${uri}&country=${data.country}`, {
                method: "post",
              }).then((r) => {
                console.log("-- Klarna - onChange done", r);
                if (r.status !== 200) {
                  r.text().then((t) => alert("Error: " + t));
                }

                api.resume();
              });
            },
          });
        });

        console.log("-- Klarna - Checkout configured");
      }
    };

    startPaymentProcess();
  }, []);
  return (
    <>
      <div
        id="checkout-container-div"
        className={`${classes.checkoutContainer} cart__onepage-checkoutContainerKlarna`}
      ></div>
    </>
  );
});

export default Klarna;
